
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import { capitalizeString } from '../../libs/utils'
import UserList from '../../components/userList'

import '../../styles/dashboard.css'

export default class ManageAdmins extends Component {
  constructor() {
    super()
    this.state = {
      users: null,
      searchQuery: '',
    }

    this.findAdmin = this.findAdmin.bind(this)
  }

  componentWillReceiveProps() {
    this.setState({ searchQuery: this.state.searchQuery })
  }

  findAdmin(e) {
    e.preventDefault()
    const query = this.search.value
    if (query.length >= 3 || query.length === 0) {
      this.setState({ searchQuery: query })
    } else {
      this.props.setDashboardMessage('info', 'Search query length must be at least 3 characters long')
    }
  }

  render() {
    const user = this.props.user
    // if we have a user session we redirect away from sign up
    if (!user || !user.id) {
      return (
        <Redirect
          to={{
            push: true,
            rtURL: `/${this.props.type}/manage`,
            rtProps: this.props.location.state,
            pathname: '/login',
          }}
        />
      )
    }
    return (
      <div className="user-dash-wrapper">
        <div className="sub-page-header col-sm-12">
          <h2>Manage {capitalizeString(this.props.type)}</h2>
          <div className="right-options">
            <div className="search">
              <form
                onSubmit={e => {
                  this.findAdmin(e)
                }}
              >
                <div className="form-element">
                  <input
                    ref={input => {
                      this.search = input
                    }}
                    type="text"
                    className="form-text"
                    placeholder="Enter search term"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-12 col-lg-12">
          <div className="module focus green">
            <div className="module-header" />
          {
            (user.role !== 'admin' && user.role !== 'super_admin') ?
            <div className="bg_white">
              <p className="bg_text">You're not allowed to view this page</p>
              <p style={{textAlign: "center"}}>Kindly speak with the admin</p>
            </div>
            :
            <UserList
              query={this.state.searchQuery}
              setDashboardMessage={this.props.setDashboardMessage}
              type={this.props.type}
            />
          }
          </div>
        </div>
      </div>
    )
  }
}

ManageAdmins.propTypes = {
  user: PropTypes.object,
  type: PropTypes.string,
  location: PropTypes.shape({
    state: PropTypes.object,
  }),
  setDashboardMessage: PropTypes.func,
}

ManageAdmins.defaultProps = {
  user: null,
  type: 'admins',
  location: {
    state: {},
  },
  setDashboardMessage: () => { },
}
